import SelectComponent from 'react-select';
import SelectCreatable from 'react-select/creatable';
import styled, { css } from 'styled-components';

// Style the regular Select
export const Select = styled(SelectComponent)`
  .react-select__control {
    border-radius: 10px !important;
    border: 2px solid #e2e8f0 !important;
    min-height: 46px !important;
    transition: all 0.25s ease !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
    background: white !important;

    &:hover {
      border-color: #a0aec0 !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
      transform: translateY(-1px);
    }

    &:focus-within {
      border-color: #667eea !important;
      box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.15) !important;
      transform: translateY(-1px);
    }
  }

  .react-select__single-value {
    color: #2d3748 !important;
    font-weight: 500 !important;
    font-size: 14px !important;
  }

  .react-select__placeholder {
    color: #a0aec0 !important;
    font-weight: 400 !important;
    font-size: 13px !important;
  }

  .react-select__indicator-separator {
    display: none !important;
  }

  .react-select__dropdown-indicator {
    color: #a0aec0 !important;

    &:hover {
      color: #667eea !important;
    }
  }

  .react-select__menu {
    border-radius: 10px !important;
    border: 2px solid #e2e8f0 !important;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.12) !important;
    overflow: hidden !important;
    margin-top: 6px !important;
    background: white !important;
    animation: slideDown 0.2s ease !important;
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .react-select__menu-list {
    padding: 6px 0 !important;
    max-height: 300px !important;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c7cd;
      border-radius: 10px;
      transition: background 0.2s ease;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a0aec0;
    }

    scrollbar-width: thin;
    scrollbar-color: #c1c7cd #f1f1f1;
  }

  .react-select__option {
    padding: 12px 16px !important;
    transition: all 0.15s ease !important;
    font-weight: 500 !important;
    font-size: 13px !important;
    color: #2d3748 !important;
    cursor: pointer !important;
    background: white !important;

    &:hover {
      background: #f0f4ff !important;
      color: #2d3748 !important;
    }
  }

  .react-select__option--is-focused {
    background: #ebf4ff !important;
    color: #2d3748 !important;
  }

  .react-select__option--is-disabled {
    color: #a0aec0 !important;
    cursor: not-allowed !important;
    opacity: 0.6 !important;
  }

  /* Error state - Fixed border */
  ${({ invalid, theme }) =>
    invalid &&
    css`
      .react-select__control {
        border-color: ${theme?.colors?.danger || '#ef4444'} !important;
        border-width: 1.5px !important;
        box-shadow: none !important;

        &:hover {
          border-color: ${theme?.colors?.danger || '#ef4444'} !important;
        }

        &.react-select__control--is-focused {
          border-color: ${theme?.colors?.danger || '#ef4444'} !important;
          box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.15) !important;
        }
      }
    `}

  /* Disabled state */
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      .react-select__control {
        background: #f7fafc !important;
        opacity: 0.7 !important;
        cursor: not-allowed !important;

        &:hover {
          transform: none !important;
          box-shadow: none !important;
        }
      }
    `}
  
  /* Small size */
  ${({ size }) =>
    size === 'sm' &&
    css`
      .react-select__control {
        min-height: 34px !important;
        border-radius: 8px !important;
      }

      .react-select__single-value {
        font-size: 12px !important;
      }

      .react-select__option {
        padding: 8px 12px !important;
        font-size: 12px !important;
      }
    `}
  
  /* Large size */
  ${({ size }) =>
    size === 'lg' &&
    css`
      .react-select__control {
        min-height: 52px !important;
        border-radius: 12px !important;
      }

      .react-select__single-value {
        font-size: 16px !important;
      }

      .react-select__option {
        padding: 14px 20px !important;
        font-size: 15px !important;
      }
    `}
`;

// Style the Creatable Select
export const StyledSelectCreatable = styled(SelectCreatable)`
  /* Same styles as above, copied */
  .react-select__control {
    border-radius: 10px !important;
    border: 2px solid #e2e8f0 !important;
    min-height: 46px !important;
    transition: all 0.25s ease !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
    background: white !important;

    &:hover {
      border-color: #a0aec0 !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
      transform: translateY(-1px);
    }

    &:focus-within {
      border-color: #667eea !important;
      box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.15) !important;
      transform: translateY(-1px);
    }
  }

  /* ... copy all the other styles from above ... */

  /* Error state - Fixed border */
  ${({ invalid, theme }) =>
    invalid &&
    css`
      .react-select__control {
        border-color: ${theme?.colors?.danger || '#ef4444'} !important;
        border-width: 1.5px !important;
        box-shadow: none !important;

        &:hover {
          border-color: ${theme?.colors?.danger || '#ef4444'} !important;
        }

        &.react-select__control--is-focused {
          border-color: ${theme?.colors?.danger || '#ef4444'} !important;
          box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.15) !important;
        }
      }
    `}

  /* Creatable specific - the "Create" option */
  .react-select__option--is-creatable {
    color: #667eea !important;
    font-weight: 500 !important;
    border-top: 1px dashed #e2e8f0 !important;
    margin-top: 4px !important;
    padding-top: 10px !important;

    &::before {
      content: '+ ';
      font-weight: 700;
    }
  }
`;
